import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/sistema-de-contabilidad/ContabilidadClient.tsx");
